import { Inject, Injectable } from '@angular/core';
import { IWidgetRestClient } from "../../../rest-clients/application/widget/i-widget-rest.client";
import { widgetRestClientInjectionToken } from "../../../rest-clients/application/widget/widget-rest-client-injection-token";
import { IWidgetService } from "./i-widget.service";
import { ICreateApplicationForm } from "../../../rest-clients/application/forms/i-create-application.form";
import { IGetApplicationPageForm } from "../../../rest-clients/application/forms/i-get-application-page.form";
import { IWidget } from "../../../models/application/i-widget";
import { ICreateRecordResponse, IPage } from '@zaeper/communication-lib';

@Injectable()
export class WidgetService implements IWidgetService {
  constructor(@Inject( widgetRestClientInjectionToken ) private readonly _widgetRestClient: IWidgetRestClient) {
  }

  public async createWidgetDraft(form: ICreateApplicationForm): Promise<string> {
    const response: ICreateRecordResponse = await this._widgetRestClient.createApplication( form );
    return Promise.resolve( response.recordId );
  }

  public async getWidgetPage(form: IGetApplicationPageForm): Promise<IPage<IWidget>> {
    return this._widgetRestClient.getApplicationPage( form );
  }
}
